// extracted by mini-css-extract-plugin
export default {"legalNoticeContainer":"styles_legalNoticeContainer__UU6+O","title":"styles_title__wJ00w","btn":"styles_btn__QpbCi"};